module.exports = __webpack_public_path__ + "static/media/govt.c01d1455.png";